import styled from 'styled-components';

import { ReactComponent as PeopleIcon } from '../../../../../../../assets/icons/people-icon.svg';
import colors from '../../../../../../../styles/colors';

const StyledPeopleIcon = styled(PeopleIcon)`
  width: 27px;
  height: 29px;
  margin-bottom: 9px;
`;

const ActionButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const SearchContainer = styled.div`
  padding: 0px 40px;
`;

const CommunityList = styled.div`
  padding: 10px 0;
  max-height: 20vh;
  overflow-y: auto;
`;

const CommunityRow = styled.div`
  border-bottom: 1px solid ${colors.shades.secondary7};
  padding: 4px 50px;
`;

const RowLabel = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const NoResultsText = styled.p`
  padding: 12px 50px;
  color: ${colors.shades.secondary3};
  font-size: 14px;
  margin: 0;
`;

export {
  StyledPeopleIcon,
  ActionButtonsRow,
  SearchContainer,
  CommunityList,
  CommunityRow,
  RowLabel,
  NoResultsText,
};
